export default {
  setConsorcios(state, payload) {
    state.consorcios = payload
  }
}
